import ViewState from './ViewState'
import { _allowStateChanges } from 'mobx'
import { serialize, update } from 'serializr'
import { getDcCounts } from '../utils/FlyBaseIds'
import Query from './Query'

import { DEFAULT_SPECIES } from '../constants'

export function initStore(key) {
  const storeJSON = sessionStorage.getItem(key)
  let store = new ViewState(key)
  let isNew = true

  if (storeJSON) {
    try {
      // Mobx strict mode was interferring with deserialization step
      // for the ViewState.itemStore prop.
      _allowStateChanges(true, () => {
        update(store, JSON.parse(storeJSON))
      })
      isNew = false
    } catch (e) {
      store = new ViewState(key)
    }
  }

  const ids = window.FlyBaseHitList.ids
  let counts = window.FlyBaseHitList.counts
  const query = window.FlyBaseHitList.query
  let filters = (window.FlyBaseHitList.filters = {})

  // Provide a default selected species if none was specified.
  if (!filters.species || !filters.species.selected) {
    filters.species = {
      selected: DEFAULT_SPECIES,
    }
  }

  // Store global variable.
  if (ids && counts) {
    store.itemStore.setIds(ids)
    store.itemStore.setCounts(counts)
  }
  // If we don't get a counts object
  // Try to calculate one ourself.
  else if (ids && !counts) {
    console.warn('No data class counts found, building our own.')
    store.itemStore.setIds(ids)
    counts = {}
    let dcCounts = getDcCounts(ids)

    for (const type of Object.keys(dcCounts)) {
      counts[type] = { count: dcCounts[type], label: type }
    }
    store.itemStore.setCounts(counts)
  }

  // Store any filter data that was passed into the HitList.
  store.filterStore.setData(filters)

  if (query) {
    store.setQuery(new Query(query.term, query.species, query.caller))
  }

  // Select all hits if this is a new HitList.
  if (isNew) {
    store.itemStore.selectAll()
  }

  console.debug('Store initialized.')
  return store
}

// Function to sync the store with the sessionStorage.
export function sync(store) {
  console.debug('Syncing with session storage.')
  sessionStorage.setItem(store.key, JSON.stringify(serialize(store)))
}
